import React, { useState, useEffect } from 'react';
import '../styles/people.css';
import { useTranslation } from 'react-i18next';
import PeopleGroup from '../components/people-group';
import Alumni from '../components/alumni'; 
import DataContext from '../contexts/DataContext';

const People = () => {
    const [finalUsers, setFinalUsers] = useState({faculty : []}); 
    const { t, i18n } = useTranslation('people');
    const { groups, people, isLoading } = React.useContext(DataContext);

    useEffect(() => {
        const usersByRole = Object.keys(people).reduce((acc, userId) => {
            const person = people[userId];
            const groupImages = groups
                .filter(group => group.members.includes(person.username)) 
                .map(group => group.logo);

            const user = {
                id: userId,
                display_name: person.display_name,
                is_active: person.is_active,
                role: person.role,
                groupImage: groupImages,
                image: person.image || "",
                bio: person.bio || "",
            };
    
            if (!acc[person.role]) {
                acc[person.role] = [];
            }
            acc[person.role].push(user);
    
            return acc;
        }, {});
    
        setFinalUsers(usersByRole);
    }, [people, groups, i18n.language]);

    if (isLoading) {
        return <div className="loading">{t('loading')}</div>;
    }

    return (
        <div className="people-container">
            
            <h1>{t('title') || 'People'}</h1>
            
            <PeopleGroup groupName="faculty" people={finalUsers.faculty} />
            <PeopleGroup groupName="master" people={finalUsers.master} />
            <PeopleGroup groupName="ugrad" people={finalUsers.ugrad} />
            <PeopleGroup groupName="postdoc" people={finalUsers.postdoc} />
            <PeopleGroup groupName="phd" people={finalUsers.phd} />
            <PeopleGroup groupName="collab" people={finalUsers.collab} />

            <Alumni finalUsers={finalUsers} />
        </div>
    );
};

export default People;